/**
 * It returns value of queryParam in passed urlString
 * @param urlString
 * @param queryParam
 * @returns {string}
 */
export default (urlString, queryParam) => {
  const url = new URL(urlString)
  return url.searchParams.get(queryParam)
}
